import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Crown, Sparkles, Zap } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface UpgradeModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function UpgradeModal({ open, onOpenChange }: UpgradeModalProps) {
  const navigate = useNavigate();

  const handleUpgrade = () => {
    onOpenChange(false);
    navigate("/subscription");
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <div className="flex flex-col items-center text-center space-y-4 py-4">
          <div className="relative">
            <div className="absolute inset-0 bg-[hsl(var(--orange))]/30 blur-2xl rounded-full" />
            <Crown className="h-16 w-16 text-[hsl(var(--orange))] relative" />
          </div>
          
          <div className="space-y-2">
            <h2 className="text-2xl font-bold">Free Generations Used!</h2>
            <p className="text-muted-foreground">
              You've used all your free generations. Upgrade to get 90 generations per month!
            </p>
          </div>

          <div className="w-full space-y-3 pt-2">
            <div className="flex items-center gap-3 text-sm">
              <Sparkles className="h-5 w-5 text-[hsl(var(--orange))] flex-shrink-0" />
              <span className="text-left">90 hairstyle generations per month</span>
            </div>
            <div className="flex items-center gap-3 text-sm">
              <Zap className="h-5 w-5 text-[hsl(var(--orange))] flex-shrink-0" />
              <span className="text-left">Priority processing</span>
            </div>
            <div className="flex items-center gap-3 text-sm">
              <Crown className="h-5 w-5 text-[hsl(var(--orange))] flex-shrink-0" />
              <span className="text-left">Save all your generations</span>
            </div>
          </div>

          <div className="w-full space-y-2 pt-4">
            <Button
              onClick={handleUpgrade}
              size="lg"
              className="w-full bg-gradient-to-r from-[hsl(var(--orange))] to-[hsl(var(--orange-glow))] hover:opacity-90 text-white"
            >
              <Crown className="mr-2 h-5 w-5" />
              Upgrade Now
            </Button>
            <Button
              onClick={() => onOpenChange(false)}
              variant="ghost"
              size="sm"
              className="w-full"
            >
              Maybe Later
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
